export * from './InlinePagePreview';

import { InlinePagePreview } from './InlinePagePreview';
export default InlinePagePreview;
